import { upsertTaskGroup } from '@dispatch/shared/services';
import { TaskGroup } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

export const useUpsertTaskGroup = (
  taskGroupId: string,
  onSuccess: () => void
) => {
  const client = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['upsert-taskGroup'],
    async (data: Partial<TaskGroup>) => upsertTaskGroup(data),
    {
      onSuccess,
      onSettled: () => {
        if (taskGroupId) {
          client.invalidateQueries(['task-group', taskGroupId]);
          client.invalidateQueries('task-groups');
        }
      },
    }
  );

  return {
    upsertTaskGroup: mutate,
    error,
    status,
  };
};
